import { useSelector } from 'react-redux';

// Like useIsAuthorised, but also exposes whether the boot-time/login/refresh
// cycle has resolved at least once - needed by call sites that must not act
// (e.g. redirect) while that's still unknown.
export default function useAuthStatus() {
    return useSelector(state => ({
        isAuthenticated: state.auth.isAuthenticated,
        checked: state.auth.checked
    }));
}
